import Service from '../../service';

const UserService = {
  // Get all users
  getAllUsers: async (
    token,
    currentPage,
    items_per_page,
    body = null
  ) => {
    try {
      return await Service.post({
        url: `/accounts/user/admin/list${currentPage ? `?current_page=${currentPage}` : ''}${items_per_page ? `&items_per_page=${items_per_page}` : ''}`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },

  // get authorizedModules
  authorizedModules: async (token) => {
    try {
      return await Service.get(`/accounts/authorized-modules`, token);
    } catch (error) {
      throw error;
    }
  },

  // Add new user
  addUser: async (token, body = null) => {
    try {
      return await Service.post({
        url: `/accounts/user/admin`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  //delete user
  deleteUser: async (id, token) => {
    try {
      return await Service.remove({
        url: `/accounts/user/admin?userId=${id}`,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  // block user
  blockUser: async (token, body = null) => {
    try {
      return await Service.update({
        url: '/accounts/user/admin/block',
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
  // update user
  updateUser: async (token, body) => {
    try {
      return await Service.update({
        url: '/accounts/user/admin',
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },
    // invite user by email
  inviteUserByEmail: async (token, body = null) => {
    try {
      return await Service.post({
        url: `/accounts/user/userEmail`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },

  // Send Notification
  sendNotification: async ({token, body}) => {
    try {
      return await Service.post({
        url: `/accounts/user/notification`,
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },

  // get notification settings / subscriptions
  getNotificationSettings: async ({token}) => {
    try {
      return await Service.get(`/accounts/user/notification-subscription`, token);
    } catch (error) {
      throw error;
    }
  },

  // update notification settings / subscriptions
  updateNotificationSettings: async ({token, body}) => {
    try {
      return await Service.update({
        url: '/accounts/user/notification-subscription',
        token,
        data: body,
      });
    } catch (error) {
      throw error;
    }
  },

  // get payment gateways
  getPaymentGateways: async ({token}) => {
    try {
      return await Service.get(`/accounts/org/payment-gateway/list`, token);
    } catch (error) {
      throw error;
    }
  },

  // add payment gateway
  addPaymentGateway: async ({token, data}) => {
    try {
      return await Service.post({
        url: `/accounts/org/payment-gateway`,
        token,
        data,
      });
    } catch (error) {
      throw error;
    }
  },

  // delete payment gateway
  deletePaymentGateway: async ({token, id}) => {
    try {
      return await Service.remove({
        url: `/accounts/org/payment-gateway?id=${id}`,
        token,
      });
    } catch (error) {
      throw error;
    }
  },

  // Disable Member Portal User
  disableMemberUser: async ({token,contactId}) => {
    try {
      return await Service.remove({
        url: `/accounts/user/userEmail?contactId=${contactId}`,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
};

export default UserService;
